<template>
  <div class="service-garden-item" :class="{hover: itemHover}">
    <md-icon v-if="isIcon">{{ serviceIcon }}</md-icon>
    <div v-else  class="bn-icon" :style="bnIconProps"></div>
    <h3 v-html="$t(`${view}.${name}_SERVICE_GARDEN_HEADING`)"></h3>
    <p v-html="$t(`${view}.${name}_SERVICE_GARDEN_BODY`)"></p>
    <md-button
      v-if="href"
      :to="{ path: `/${href}` }"
      @mouseout="ctaExit"
      @mouseover="ctaHover"
      class="md-dense md-accent md-raised md-primary">{{$t(`${view}.${name}_SERVICE_GARDEN_CTA`)}}</md-button>
  </div>
</template>

<script>
import style from 'styles/service-garden.scss'
import {MARKETING_PANEL_LAYOUT} from 'app-constants'
export default {
  props: ['view', 'name', 'icon', 'href', 'avatar'],
  data() {

    let itemHover = false
    let isIcon = (this.icon.type === 'icon');
    let serviceIcon = (this.icon.type === 'icon')
        ? this.icon.name.toLowerCase()
        : require(`assets/img/${this.view}/icons/${this.icon.name.toLowerCase()}.png`)

    // ${require(`assets/img/${this.view}/icons/${this.icon.name.toLowerCase()}
    let bnIconProps = {
      backgroundImage: `url('${serviceIcon}')`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    }


    return {
      bnIconProps,
      itemHover,
      isIcon,
      serviceIcon
    }
  },
  mounted() {
  },
  methods: {
    ctaHover () {
      this.itemHover = true
    },
    ctaExit () {
      this.itemHover = false
    }
  }
}
</script>
